export var ClaimType;
(function (ClaimType) {
    ClaimType["CAN_ACCESS_SITENAME"] = "CAN_ACCESS_SITENAME";
    ClaimType["CAN_ACCESS_BRAND"] = "CAN_ACCESS_BRAND";
    ClaimType["CAN_ACCESS_MARKET"] = "CAN_ACCESS_MARKET";
    ClaimType["ACCESS_RESTRICTED_FEATURES"] = "ACCESS_RESTRICTED_FEATURES";
    ClaimType["IS_ADMIN"] = "IS_ADMIN";
})(ClaimType || (ClaimType = {}));
